import { message } from 'antd';
import { get } from 'lodash';
import { useMutation } from '@apollo/react-hooks';
import { DELETE_ALERTS, ALERT_SUMMARY_QUERY } from '@api/graphql/manualAlerts';

const useDelete = () => {
  const [deleteAlerts] = useMutation(DELETE_ALERTS(), {
    update(cache, {data}) {
      const query = ALERT_SUMMARY_QUERY();
      const cachedData: any = cache.readQuery({ query });
      const existing = get(cachedData, 'manualAlertsByType') ;
      const remaining = get(data, 'deleteManualAlerts', []).map(a => a.id);
      const remainingAlerts = existing.filter(alert => remaining.includes(alert.id));
      cachedData.manualAlertsByType = remainingAlerts;
      cache.writeQuery({
        query,
        data: cachedData,
      });
    },
    onCompleted() {
      message.success(`Alert deleted!`);
    }
  });
  return deleteAlerts;
}

export default useDelete;
